import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Explanation() {
    return (
        <OnboardingBody title='Setting up tracking'>
            <p>
                To track where your website visitors are coming from, we provide a small snippet of
                code to embed on your website.
            </p>
            <p>This helps answer questions like:</p>
            <BulletedList
                bullets={[
                    <span key='1'>Did someone click on one of my ads?</span>,
                    <span key='2'>Did a Google search lead someone to my site?</span>,
                    <span key='3'>Did they hear about my website via social media?</span>,
                ]}
            />
        </OnboardingBody>
    );
}
